import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderExecutionControlTime extends BaseModelAPI {
	static entity = 'workorderexecutioncontroltime';
	static entityName = 'workorderexecutioncontroltime';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.workOrderExecutionId = '';
			this.workOrderExecution = {};
			this.productionControlTimeId = '';
			this.productionControlTime = {};
			this.startControlTime = '';
			this.stopControlTime = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	// static async generateControlTime(this_, id, machineId) {
    //     return await this_.$http.get(`${this.entityName}/generatecontroltime/${id}/${machineId}`)
    //         .then(async function(response){
	// 			console.log("response generatecontroltime", response);
    //             return response.data;
    //         })
    //         .catch(function(error){
    //             this_.$store.dispatch('addErrorMessageGlobal', error);
    //             throw error;
    //         });
    // }

	static async productionControlSetting(this_, id) {
        return await this_.$http.post(`${this.entityName}/productioninputsetting/${id}`)
            .then(async function(response){
				console.log("response productioninputsetting", response);
                return response.data;
            })
            .catch(function(error){
                this_.$store.dispatch('addErrorMessageGlobal', error);
                throw error;
            });
    }

}